var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.userHasPermissionTo("list")
        ? _c(
            "div",
            [
              _c("v-data-table", {
                staticClass: "elevation-2",
                class: {
                  "no-show-permission": !_vm.userHasPermissionTo("show")
                },
                attrs: {
                  headers: _vm.headers,
                  items: _vm.ticketComments,
                  page: _vm.pagination.page,
                  "items-per-page": _vm.paginationTicketComments.rowsPerPage,
                  "items-per-page-text": _vm.rowsPerPageText,
                  "items-per-page-items": _vm.rowsPerPageItems,
                  "header-props": { sortIcon: _vm.sortIcon },
                  "footer-props": {
                    prevIcon: _vm.prevIcon,
                    nextIcon: _vm.nextIcon,
                    "items-per-page-options": _vm.rowsPerPageItems
                  }
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.pagination, "page", $event)
                  },
                  "update:itemsPerPage": function($event) {
                    return _vm.$set(
                      _vm.paginationTicketComments,
                      "rowsPerPage",
                      $event
                    )
                  },
                  "update:items-per-page": function($event) {
                    return _vm.$set(
                      _vm.paginationTicketComments,
                      "rowsPerPage",
                      $event
                    )
                  },
                  pagination: function($event) {
                    return _vm.setRowsOnLocalStorage(
                      _vm.dataTableTicketCommentsTableId,
                      _vm.paginationTicketComments.rowsPerPage
                    )
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item",
                      fn: function(props) {
                        return [
                          _c(
                            "tr",
                            {
                              class: {
                                "cursor-pointer": _vm.userHasPermissionTo(
                                  "show"
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.viewItem(props.item)
                                }
                              }
                            },
                            [
                              _c("td", [_vm._v(_vm._s(props.item.id))]),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "text-overflow": "ellipsis",
                                    overflow: "hidden",
                                    "white-space": "nowrap",
                                    "max-width": "800px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(props.item.text) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(props.item.author.name))
                              ]),
                              _vm._v(" "),
                              _vm.userCanEditOrRemoveItems
                                ? _c(
                                    "td",
                                    [
                                      _c("app-datatable-action-buttons", {
                                        attrs: {
                                          "user-can-delete": _vm.userCanDeleteComment(
                                            props.item.author.id
                                          ),
                                          "user-can-edit": _vm.userCanEditComment(
                                            props.item.author.id
                                          )
                                        },
                                        on: {
                                          delete: function($event) {
                                            return _vm.askConfirmationToDeleteItem(
                                              props.item
                                            )
                                          },
                                          edit: function($event) {
                                            return _vm.editComment(
                                              props.item.id
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      }
                    },
                    {
                      key: "pageText",
                      fn: function(props) {
                        return [
                          _vm._v(
                            "\n        " +
                              _vm._s(props.pageStart) +
                              " - " +
                              _vm._s(props.pageStop) +
                              " " +
                              _vm._s(_vm.$t("tables.Of")) +
                              "\n        " +
                              _vm._s(props.itemsLength) +
                              "\n      "
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3913731877
                )
              }),
              _vm._v(" "),
              _c("app-dialog-box", {
                attrs: {
                  open: _vm.deleteDialog,
                  title: _vm.$t("DeleteComment"),
                  content:
                    _vm.$t("DeleteConfirmation") +
                    " " +
                    _vm.itemToDelete.id +
                    "?",
                  "main-action-label": _vm.$t("No"),
                  "secondary-action-label": _vm.$t("Yes"),
                  loading: _vm.loadingDelete
                },
                on: {
                  mainAction: _vm.cancelDelete,
                  secondaryAction: _vm.deleteComment
                }
              })
            ],
            1
          )
        : _c("app-no-permission-warning")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c745ca1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c745ca1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support/TechnicalSupport/TicketCommentsTable.vue
// module id = null
// module chunks = 